<template>
  <button
    type="button"
    @click.prevent="isOpenDropdown = !isOpenDropdown"
    v-click-outside="() => (isOpenDropdown = false)"
    class="form-group tag-form-picker-group"
  >
    <label class="form-control-label">Форма</label>
    <div class="form-control form-control-light custom-form-input">
      <div class="base-form">
        <img
          :src="forms.find((f) => f.name === selectedForm).src"
          :alt="selectedForm"
        />
      </div>
      <div :class="[{ rotated: isOpenDropdown }]">
        <ico name="icoArrowDropDown" />
      </div>
      <div
        @click.stop
        :class="[
          'form-control',
          'form-control-light',
          'custom-form-picker-dropdown',
          { 'custom-form-picker-dropdown-open': isOpenDropdown },
        ]"
      >
        <div
          @click.prevent="selectForm(form.name)"
          v-for="form in forms"
          :key="form.name"
          class="form-shape"
        >
          <img :src="form.src" :alt="form.name" />
        </div>
      </div>
    </div>
  </button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TagCustomFormPicker",
  props: {
    selectedForm: {
      type: String,
      required: true,
    },
  },
  emits: ["formSelected"],
  computed: {
    ...mapGetters("tags", ["forms"]),
  },
  data() {
    return { isOpenDropdown: false };
  },
  methods: {
    selectForm(color) {
      this.$emit("formSelected", color);
      this.isOpenDropdown = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/commonStyles.less";

.tag-form-picker-group {
  width: max-content;
  margin: 0 !important;

  .custom-form-input {
    width: 70px;
    padding: 0 6px 0 15px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .custom-form-picker-dropdown {
      display: none;
      position: absolute;
      z-index: 999;
      left: -2px;
      top: 53px;
      width: max-content;
      height: max-content;
      background-color: #ffffff;
      padding: 13px;
      box-shadow: 0px 4px 25px 0px #00000040;
      &-open {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(2, 17px);
        gap: 15px;
      }

      .form-shape {
        width: max-content;
        height: 17px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .rotated {
      transform: rotate(180deg);
    }
  }
}

.base-form {
  min-width: 17px;
  min-height: 17px;
  width: 17px;
  height: 17px;
}
</style>
